/*
 * Utilities
 */

import './utils/remove-active';

/*
 * Polyfills
 */
import './polyfills/object-fit';

/*
 * Modules
 */

//import './modules/lozad-lazy-load';
import './modules/aos';
import './modules/header';
import './modules/hero-slider';
import './modules/video-fit';
import './modules/masonry-layout';
import './modules/btn';
import './modules/year-filter';
import './modules/browser-check';
import './modules/page-fade';
import './modules/post-slider';
import './modules/swiper-sliders';
import './modules/static-header';
import './modules/static-header';